export const dietText = (() => ({
  apple: `
  炭水化物の代謝が苦手なため、米、パン、じゃがいも、菓子類などの過剰摂取を避けることをおすすめします。

  コロナ禍で外出の自粛など活動が制限される生活において、健康的に過ごすために、玄米や大麦、全粒粉パンなど食物繊維を豊富に含む全粒穀物をとり入れましょう。糖の摂取量を抑えられます。
  
  ソースやケチャップといった調味料やジュース、アルコールなどの食品加工又は調理中に加えられる糖類（遊離糖類：フリーシュガー)に特に注意しましょう。
  
  ウエストひねり、腹筋運動、ジョギング、水泳などの運動は身体機能が活性化することにより、糖の代謝も活発となり、内臓脂肪の減少が期待されています。
  `,
  pear: `
  脂質の代謝が苦手なため、揚げ物や炒め物、霜降り肉、バターなどの過剰摂取を避けることをおすすめします。

  コロナ禍で外出の自粛など活動が制限される生活において、健康的に過ごすために、低脂質な鶏のむね肉やささみ肉を、また、牛や豚ではロースやヒレといった赤肉の部位を選びましょう。また良質な脂質を含む魚類を積極的にとり入れましょう。

  ランニング、下半身のストレッチ、ベンチスクワット、ストレッチなどの運動は、身体機能が活性化することにより、脂質の代謝も活発となり、また、下腹部、太もも、およびお尻の引き締め効果が期待されています。 
  `,
  banana: `
  エネルギーを消費しやすく、たんぱく質も利用されやすいため、良質なたんぱく質を含む食品を意識的にとりいれることをおすすめします。

  コロナ禍で外出の自粛など活動が制限される生活において、健康的に過ごすために、高たんぱく質で低脂質な大豆・大豆製品、魚介類、鶏のむね肉やささみ肉を積極的にとり入れましょう。

  ウォーキング、背筋運動、ウエイトトレーニングなどの運動は大きな筋肉を鍛えることができ、筋肉増強が期待されています。
  `,
  adameve: `
  肥満に関連する3つの遺伝子に多型がないため、肥満タイプに関する遺伝的な影響を受けません。

  コロナ禍で外出の自粛など活動が制限される生活において、健康的に過ごすために、定食型の食事を意識することで栄養バランスが整いやすくなり、摂取エネルギーを管理につながりやすいのでおすすめです。 
  
  外出の自粛により体力低下や体重の増加、腰痛、肩こり、疲労、ストレスの蓄積など様々な影響が懸念されています。ウォーキングやジョギング、筋トレ、ヨガなどをとり入れましょう。
  `

}))

export const muscleText = (() => ({
  fast: `
  速筋線維が発達する傾向があるため、瞬間的な強さ、スプリント、パワーを必要とするスポーツが適しています。

  400m以下の短距離陸上競技、200m以下の水泳、短距離自転車競技、サッカーやハンドボールのゴールキーパーなどが例として挙げられます。

  行動が制限されているコロナ禍では、チームで運動をすることは難しいかもしれませんが、体力的に可能であれば、高強度トレーニングを行うことを考慮できます。

  詳細については、こちらを確認してください。
  `,
  balance: `
  速筋線維と遅筋線維の両方が発達する傾向があるため、筋力、スプリント、持久力を必要とするスポーツはすべてあなたのタイプに適しています。

  800m以下の陸上競技、ボクシング、サッカー、野球、バスケットボール、テニスなど、瞬間的なパワーと持久力の両方を必要とするスポーツが、例として挙げられます。

  行動が制限されているコロナ禍では、チームで運動をすることは難しいかもしれませんが、体力的に可能であれば、高強度トレーニングを行うことを考慮できます。

  詳細については、こちらを確認してください。
  `,
  slow: `
  遅筋線維が発達する傾向があるため、持久力を必要とする様々なスポーツがあなたに適しています。

  5,000m以上の陸上競技、400m以上の水泳、長距離サイクリング、エアロビクス、ジョギングなどのスポーツが例として挙げられます。 
  `
}))


// WEBPACK FOOTER //
// ./src/constants/SpecialCoivid19.js